import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicRoutingModule } from './public-routing.module';
import { PublicComponent } from './public.component';
import { LoginComponent } from './login/login.component';
import { ReactiveFormsModule, FormsModule, } from '@angular/forms';
import { CarouselModule, BsDatepickerModule } from 'ngx-bootstrap';
import { IndexComponent } from './index/index.component';
import { MobileloginComponent } from './mobilelogin/mobilelogin.component';
import { ApplicationComponent } from './application/application.component';
import { ApplicationstatusComponent } from './applicationstatus/applicationstatus.component';
import { AdmissionopenComponent } from './admissionopen/admissionopen.component';
import { ApplicationsuccessComponent } from './applicationsuccess/applicationsuccess.component';
import { PrintapplicationComponent } from './printapplication/printapplication.component';
import { AdsenseModule } from 'ng2-adsense';
@NgModule({
  declarations: [PublicComponent, LoginComponent, IndexComponent, MobileloginComponent, 
    ApplicationComponent, ApplicationstatusComponent, AdmissionopenComponent, ApplicationsuccessComponent, PrintapplicationComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule, FormsModule,
    PublicRoutingModule,
    CarouselModule.forRoot(),
    BsDatepickerModule.forRoot(),
    AdsenseModule.forRoot({
      adClient: 'ca-pub-4524935330023079',
      adSlot: 7783157419,
    }),
  ]
})
export class PublicModule { }
